import {PipelineTemplate,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {Stack, Table, Title} from '@mantine/core';


export const Profile = ({record}: { record: PipelineTemplate }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'Description',
            value: record.description as string,
            span: 12,
        }, {
            label: 'Pipeline Type',
            value: record.pipelineType as string,
            span: 12,
        }, {
            label: 'Archetype',
            value: record.archetype || 'n/a',
            span: 12,
        }, {
            label: 'Build Command',
            value: record.buildCommand || 'n/a',
            span: 12,
        }];

    const properties2 = [
        {
            label: 'Created By',
            value: record.createdByUsername || 'n/a',
            span: 12,
        },
        {
            label: 'Managed By',
            value: record.managedByUsername || 'n/a',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>

            {record.stages && record.stages.length > 0 && (
                <Stack gap={'sm'}>
                    <Title order={5}>Pipeline Stages</Title>
                    <Table striped highlightOnHover withTableBorder>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th>Name</Table.Th>
                                <Table.Th>Order</Table.Th>
                                <Table.Th>Build Provider</Table.Th>
                                <Table.Th>Deploy Provider</Table.Th>
                                <Table.Th>Requires Approval</Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {record.stages.map((stage, index) => (
                                <Table.Tr key={index}>
                                    <Table.Td>{stage.name}</Table.Td>
                                    <Table.Td>{stage.order}</Table.Td>
                                    <Table.Td>{stage.buildProvider || 'n/a'}</Table.Td>
                                    <Table.Td>{stage.deployProvider || 'n/a'}</Table.Td>
                                    <Table.Td>{stage.requiresApproval ? 'Yes' : 'No'}</Table.Td>
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </Table>
                </Stack>
            )}

            {record.defaultDeploymentAccounts && record.defaultDeploymentAccounts.length > 0 && (
                <Stack gap={'sm'}>
                    <Title order={5}>Default Deployment Accounts</Title>
                    <Table striped highlightOnHover withTableBorder>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th>Account ID</Table.Th>
                                <Table.Th>Account Name</Table.Th>
                                <Table.Th>Region</Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {record.defaultDeploymentAccounts.map((account, index) => (
                                <Table.Tr key={index}>
                                    <Table.Td>{account.accountId}</Table.Td>
                                    <Table.Td>{account.accountName || 'n/a'}</Table.Td>
                                    <Table.Td>{account.region || 'n/a'}</Table.Td>
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </Table>
                </Stack>
            )}

            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
